import toast from 'react-hot-toast'
import {useMutation, useQueryClient} from 'react-query'
import {Message, MessagePayload} from '../types'
import {prepareMessagePayload} from '../service'
import {deleteMessage, sendMessage} from '../api'

export const useMessageMutation = () => {
  const queryClient = useQueryClient()

  // Mutation for sending a message
  const sendMutation = useMutation(
    async (values: MessagePayload) => {
      const payload = prepareMessagePayload(values)
      return await sendMessage(payload)
    },
    {
      onMutate: () => {
        const toastId = toast.loading('Sending...')
        return {toastId}
      },
      onSuccess: (_, __, context) => {
        toast.success('Message Sent Successfully', {id: context?.toastId})
        queryClient.invalidateQueries(['messages'])
      },
      onError: (error, __, context) => {
        console.error('Message sending failed:', error)
        toast.error('Message Failed to Send', {id: context?.toastId})
      },
    }
  )

  // Mutation for deleting a message
  const deleteMutation = useMutation(
    async (id: Message['id']) => {
      return await deleteMessage(id)
    },
    {
      onMutate: () => {
        const toastId = toast.loading('Deleting...')
        return {toastId}
      },
      onSuccess: (_, __, context) => {
        toast.success('Message Deleted Successfully', {id: context?.toastId})
        queryClient.invalidateQueries(['messages'])
      },
      onError: (error, __, context) => {
        console.error('Message deletion failed:', error)
        toast.error('Message Failed to Delete', {id: context?.toastId})
      },
    }
  )

  return {sendMutation, deleteMutation}
}
